import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { ViewAsProvider } from './contexts/ViewAsContext';
import { AccountProvider } from './contexts/AccountContext';
import { I18nProvider } from './i18n/I18nProvider';
import { initObservability } from '@pazportal/ui';
import App from './App';
import './index.css';

void initObservability({ app: 'customer-portal' });

// Register the service worker only in production. The dev server
// hot-reload + SW caching combo is the standard pitfall — skip it.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* ignore — SW is progressive enhancement */
    });
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ViewAsProvider>
            <AccountProvider>
              <I18nProvider>
                <App />
              </I18nProvider>
            </AccountProvider>
          </ViewAsProvider>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
